import api from './api';

export const accountingService = {
  // Chart of Accounts
  async getChartOfAccounts() {
    const response = await api.get('/accounting/chart-of-accounts');
    return response.data;
  },

  async getLedgerAccount(id) {
    const response = await api.get(`/accounting/chart-of-accounts/${id}`);
    return response.data;
  },

  async createLedgerAccount(accountData) {
    const response = await api.post('/accounting/chart-of-accounts', accountData);
    return response.data;
  },

  async updateLedgerAccount(id, accountData) {
    const response = await api.put(`/accounting/chart-of-accounts/${id}`, accountData);
    return response.data;
  },

  async deleteLedgerAccount(id) {
    const response = await api.delete(`/accounting/chart-of-accounts/${id}`);
    return response.data;
  },

  // Journal Entries
  async createJournalEntry(entryData) {
    const response = await api.post('/accounting/journal-entries', entryData);
    return response.data;
  },

  async postJournalEntry(id) {
    const response = await api.post(`/accounting/journal-entries/${id}/post`);
    return response.data;
  },

  async getJournalEntries(params = {}) {
    const response = await api.get('/accounting/journal-entries', { params });
    return response.data;
  },

  async getJournalEntry(id) {
    const response = await api.get(`/accounting/journal-entries/${id}`);
    return response.data;
  },

  // Financial Reports
  async getTrialBalance(as_on_date) {
    const response = await api.get('/accounting/trial-balance', { params: { as_on_date } });
    return response.data;
  },

  async getGeneralLedger(account_id, from_date, to_date) {
    const response = await api.get('/accounting/general-ledger', {
      params: { account_id, from_date, to_date }
    });
    return response.data;
  },

  async getProfitLoss(from_date, to_date) {
    const response = await api.get('/accounting/profit-loss', { params: { from_date, to_date } });
    return response.data;
  },

  async getBalanceSheet(as_on_date) {
    const response = await api.get('/accounting/balance-sheet', { params: { as_on_date } });
    return response.data;
  },

  async getCashFlow(from_date, to_date) {
    const response = await api.get('/accounting/cash-flow', { params: { from_date, to_date } });
    return response.data;
  }
};